export interface IEmailTemplateRegistration {
    email_has_been_sent_phrase: string;
    footer_text: string;
    subject: string;
    verify_your_email_address_phrase: string;
    phrase: string;
}
